import { useEffect, useRef, useState } from "react";

// Refresh often enough for a bar to fill smoothly.
const TICK_MS = 100;

/**
 * Counts down to `endsAt` (epoch ms) and calls `onDone` once it passes.
 * Returns the milliseconds left. The deadline, not the mount, sets the pace:
 * a caller remounted mid-count picks up where it was.
 */
export function useCountdown(endsAt: number, onDone: () => void): number {
  const [left, setLeft] = useState(() => Math.max(0, endsAt - Date.now()));
  // The latest callback, so a caller re-rendering mid-count is not restarted.
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining = Math.max(0, endsAt - Date.now());
      setLeft(remaining);
      if (remaining === 0) {
        clearInterval(timer);
        onDoneRef.current();
      }
    }, TICK_MS);
    return () => {
      clearInterval(timer);
    };
  }, [endsAt]);

  return left;
}
